import { render, staticRenderFns } from "./SsnReveal.vue?vue&type=template&id=48031df2"
import script from "./SsnReveal.vue?vue&type=script&lang=ts"
export * from "./SsnReveal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports